/**
 * Concordância com o dia da semana: segunda a sexta são femininos ("suas
 * sextas", "próxima quinta"); sábado e domingo, masculinos ("seus sábados",
 * "próximo domingo"). Recebe o nome no singular ou no plural, como a API manda.
 */
export function wdGender(name) {
  const m = /^(s[áa]bado|domingo)/i.test(String(name || "").trim());
  return {
    o: m ? "o" : "a", os: m ? "os" : "as",
    um: m ? "um" : "uma", num: m ? "num" : "numa",
    seus: m ? "seus" : "suas", dos: m ? "dos" : "das",
    proximo: m ? "próximo" : "próxima", ultimos: m ? "últimos" : "últimas",
  };
}

export const cap = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);
